import { NgModule } from '@angular/core';

import { MarketingContainerModule } from '../components/marketing-container/marketing-container.module';
import { ForgottenPasswordModule } from '../modules/forgotten-password/forgotten-password.module';
import { LoginModule } from '../modules/login/login.module';
import { MaintenanceModule } from '../modules/maintenance/maintenance.module';
import { OauthCheckrModule } from '../modules/oauth-checkr/oauth-checkr.module';
import { OauthLinkedInModule } from '../modules/oauth-linkedin/oauth-linkedin.module';
import { OauthOpenApiModule } from '../modules/oauth-open-api/oauth-open-api.module';
import { OauthQuestionnaireModule } from '../modules/oauth-questionnaire/oauth-questionnaire.module';
import { RegisterModule } from '../modules/register/register.module';
import { ResetPasswordModule } from '../modules/reset-password/reset-password.module';
import { SSOModule } from '../modules/sso/sso.module';
import { TwoFactorModule } from '../modules/two-factor/two-factor.module';
import { VerifyAccountModule } from '../modules/verify-account/verify-account.module';
import { PipeModule } from '../pipes/pipe.module';
import {SignupModule} from "../modules/signup/signup.module";

const modules = [
    LoginModule,
    SignupModule,
    ForgottenPasswordModule,
    ResetPasswordModule,
    PipeModule,
    MaintenanceModule,
    OauthCheckrModule,
    OauthLinkedInModule,
    TwoFactorModule,
    OauthOpenApiModule,
    OauthQuestionnaireModule,
    RegisterModule,
    VerifyAccountModule,
    MarketingContainerModule,
    SSOModule
];

@NgModule({
    imports: [...modules],
    exports: [...modules]
})
export class SharedModule {}
